import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import logo from './assets/logo.png';

export default function Layout({ children }){
  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar expand="lg" variant="dark" className="navbar-vm shadow-sm">
        <Container fluid="md">
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2">
            <img src={logo} alt="VMD Partner" />
            <span className="fw-bold">VMD Partner</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="nav" />
          <Navbar.Collapse id="nav">
            <Nav className="ms-auto small">
              <NavLink to="/terms" className="nav-link">Terms</NavLink>
              <NavLink to="/privacy" className="nav-link">Privacy</NavLink>
              <NavLink to="/deactivate" className="nav-link text-danger">Deactivate</NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container fluid="md" className="flex-grow-1 py-4">
        {children}
      </Container>

      <footer className="footer mt-auto py-3">
        <Container fluid="md" className="text-center small">
          <div>Official partner console for Village Milk (Trademark owner).</div>
          <div className="mt-1">
            Contact:
            {' '}
            <a href="mailto:carevillagemilk@gmail.com" className="text-decoration-none">carevillagemilk@gmail.com</a>
            {' '}| Mobile:{' '}
            <a href="tel:8960060092" className="text-decoration-none">8960060092</a>
          </div>
        </Container>
      </footer>
    </div>
  );
}